import React from 'react';

import Button from 'CommonComponents/Button';

import { useBulkDelete } from 'Context/BulkDeleteContext';

import CircleCancelIcon from 'Assets/icons/circle-xmark.svg';
import MinusCircleIcon from 'Assets/icons/minus-circle.svg';
import TrashIcon from 'Assets/icons/trash.svg';

const BulkDeleteControls = ({ disabled, loading, deleteManyDisabled, deleteAllDisabled, onDeleteAll, onDeleteMany }) => {
    const bulkDelete = useBulkDelete();

    return (
        <div className="tw-flex tw-justify-end tw-gap-x-1.5">
            {bulkDelete.isSelectMode && (
                <>
                    <Button
                        variant="danger"
                        onClick={() => onDeleteMany()}
                        loading={loading}
                        disabled={disabled || deleteManyDisabled || bulkDelete.selectedCount === 0}
                    >
                        <TrashIcon className="tw-w-3.5 tw-h-3.5" />
                        {$t('Delete Selected')}
                    </Button>
                    <Button variant="secondary" onClick={() => bulkDelete.setAllMode()}>
                        <CircleCancelIcon className="tw-w-3.5 tw-h-3.5" />
                        {$t('Cancel Delete')}
                    </Button>
                </>
            )}
            {bulkDelete.isAllMode && (
                <>
                    <Button variant="danger" onClick={() => onDeleteAll()} loading={loading} disabled={disabled || deleteAllDisabled}>
                        <TrashIcon className="tw-w-3.5 tw-h-3.5" />
                        {$t('Delete All')}
                    </Button>
                    <Button variant="secondary" onClick={() => bulkDelete.setSelectMode()}>
                        <MinusCircleIcon className="tw-w-3.5 tw-h-3.5" />
                        {$t('Delete Many')}
                    </Button>
                </>
            )}
        </div>
    );
};

export default BulkDeleteControls;
